import { render, staticRenderFns } from "./SearchSuggestionsAppBar.vue?vue&type=template&id=0a28a582&"
import script from "./SearchSuggestionsAppBar.vue?vue&type=script&lang=js&"
export * from "./SearchSuggestionsAppBar.vue?vue&type=script&lang=js&"
import style0 from "./SearchSuggestionsAppBar.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./SearchSuggestionsAppBar.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCombobox,VListItemContent,VListItemTitle,VTooltip})
